import { render, staticRenderFns } from "./add_fagao.vue?vue&type=template&id=7d19e66c&scoped=true&"
import script from "./add_fagao.vue?vue&type=script&lang=js&"
export * from "./add_fagao.vue?vue&type=script&lang=js&"
import style0 from "./add_fagao.vue?vue&type=style&index=0&id=7d19e66c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d19e66c",
  null
  
)

export default component.exports